/*
 * Folivana Color Gallery
 * Product-level fields:
 *   custom.color_1_name / custom.color_1_images
 *   custom.color_2_name / custom.color_2_images
 *   custom.color_3_name / custom.color_3_images
 *
 * Gallery is controlled by the selected COLOR option only.
 * Size changes reuse the same color gallery.
 */
(function () {
  'use strict';

  function normalize(value) {
    return String(value == null ? '' : value)
      .replace(/\u00a0/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function parseData(el) {
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      console.error('[Folivana Color Gallery] Invalid gallery data.', e);
      return null;
    }
  }

  function getGallery(section) {
    return section.querySelector('.product-gallery');
  }

  function makeMainSlide(productId, image, index) {
    var slide = document.createElement('div');
    slide.className = 'product-gallery__image';
    slide.dataset.productId = productId || '';
    slide.dataset.mediaType = 'image';
    slide.dataset.folivanaColorGallery = 'true';

    var link = document.createElement('a');
    link.className = 'product-gallery__link';
    link.href = image.zoom || image.src;
    link.dataset.fancybox = String(productId || 'folivana-color-gallery');
    link.title = image.alt || '';

    var container = document.createElement('div');
    container.className = 'image__container';

    var img = document.createElement('img');
    img.className = 'lazyload lazyload--fade-in';
    img.loading = index === 0 ? 'eager' : 'lazy';
    img.alt = image.alt || '';
    img.src = image.src;
    img.setAttribute('data-src', image.src);
    img.setAttribute('data-zoom-src', image.zoom || image.src);
    img.setAttribute('data-image-id', 'folivana-color-' + index);
    img.setAttribute('data-index', String(index));

    container.appendChild(img);
    link.appendChild(container);
    slide.appendChild(link);
    return slide;
  }

  function makeThumb(image, index) {
    var thumb = document.createElement('div');
    thumb.className = 'product-gallery__thumbnail one-fifth column is-relative';
    thumb.dataset.title = image.alt || '';
    thumb.tabIndex = 0;
    thumb.dataset.folivanaColorGallery = 'true';

    var img = document.createElement('img');
    img.loading = 'lazy';
    img.src = image.src;
    img.alt = image.alt || '';
    img.dataset.index = String(index);
    thumb.appendChild(img);
    return thumb;
  }

  function firstImageSrc(main) {
    var img = main && main.querySelector('.product-gallery__image img');
    return img ? (img.currentSrc || img.src || img.getAttribute('data-src') || '') : '';
  }

  function sameImage(src, wanted) {
    if (!src || !wanted) return false;
    try {
      return new URL(src, window.location.href).pathname === new URL(wanted, window.location.href).pathname;
    } catch (e) {
      return src.indexOf(wanted) !== -1 || wanted.indexOf(src) !== -1;
    }
  }

  function destroySliders(section) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.flickity) return;

    var main = section.querySelector('.product-gallery__main');
    var thumbs = section.querySelector('.product-gallery__thumbnails');

    try {
      if (main && $(main).hasClass('flickity-enabled')) $(main).flickity('destroy');
    } catch (e) {}

    try {
      if (thumbs && $(thumbs).hasClass('flickity-enabled')) $(thumbs).flickity('destroy');
    } catch (e) {}
  }

  function rebuildGallery(section, images, colorKey) {
    if (!images || !images.length) return false;

    var gallery = getGallery(section);
    var main = section.querySelector('.product-gallery__main');
    if (!gallery || !main) return false;

    var limited = images.slice(0, 5);
    if (!limited.length) return false;

    // Do not rebuild if the correct color gallery is already displayed.
    if (main.dataset.folivanaColorGalleryColor && sameImage(firstImageSrc(main), limited[0].src)) {
      return true;
    }

    destroySliders(section);

    var productId = main.dataset.productId || '';
    main.innerHTML = '';
    limited.forEach(function (image, index) {
      main.appendChild(makeMainSlide(productId, image, index));
    });
    main.dataset.mediaCount = String(limited.length);

    var thumbs = gallery.querySelector('.product-gallery__thumbnails');
    if (thumbs) {
      thumbs.innerHTML = '';
      limited.forEach(function (image, index) {
        thumbs.appendChild(makeThumb(image, index));
      });
    }

    Array.prototype.slice.call(gallery.classList).forEach(function (name) {
      if (/^product-gallery--media-amount-\d+$/.test(name)) gallery.classList.remove(name);
    });
    gallery.classList.add('product-gallery--media-amount-' + limited.length);
    main.dataset.folivanaColorGalleryActive = 'true';
    main.dataset.folivanaColorGalleryColor = colorKey || '';

    // Reuse the theme's own slideshow/lightbox setup.
    var productController = window.PXUTheme && window.PXUTheme.jsProduct && window.PXUTheme.jsProduct.product;
    var $ = window.jQuery;

    try {
      if ($ && productController && typeof productController.enableSlideshow === 'function') {
        productController.$productGallery = $(main);
        productController.enableSlideshow($(main));
        if (productController._data && productController._data.enable_product_lightbox && typeof productController.enableLightbox === 'function') {
          productController.enableLightbox($(main));
        }
      } else if ($ && $.fn && $.fn.flickity) {
        $(main).flickity({
          wrapAround: true,
          adaptiveHeight: true,
          dragThreshold: 10,
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: limited.length > 1
        });
      }
    } catch (e) {
      // Gallery markup is still valid even if a slider enhancement fails.
    }

    try {
      document.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
    } catch (e) {}

    return true;
  }

  function init(dataEl) {
    if (!dataEl || dataEl.dataset.folivanaInitialized === 'true') return;

    var section = dataEl.closest('.shopify-section') || dataEl.closest('section') || document;
    var data = parseData(dataEl);
    if (!data || !data.galleries || !Object.keys(data.galleries).length || !data.colorOptionIndex) {
      console.warn('[Folivana Color Gallery] Missing color gallery data.', data);
      return;
    }

    var picker = section.querySelector('[data-variant-selection]');
    if (!picker) {
      window.setTimeout(function () { init(dataEl); }, 500);
      return;
    }

    dataEl.dataset.folivanaInitialized = 'true';
    var activeColor = '';
    var applying = false;

    function galleryForVariant(variant) {
      if (!variant) return null;

      var options = Array.isArray(variant.options) ? variant.options : [];
      var index = Number(data.colorOptionIndex) - 1;
      var color = options[index];

      // Shopify's variant JSON also exposes option1/option2/option3.
      if (!color && index >= 0) color = variant['option' + (index + 1)];
      if (!color) return null;

      var normalizedColor = normalize(color);
      return {
        color: normalizedColor,
        images: data.galleries[normalizedColor] || null
      };
    }

    function applyVariant(variant, force) {
      var match = galleryForVariant(variant);
      if (!match || !match.images || !match.images.length) return;

      var main = section.querySelector('.product-gallery__main');
      var alreadyCorrect = main && sameImage(firstImageSrc(main), match.images[0].src);

      if (!force && activeColor === match.color && alreadyCorrect) return;

      activeColor = match.color;
      applying = true;
      rebuildGallery(section, match.images, match.color);
      window.setTimeout(function () { applying = false; }, 50);
    }

    function readVariant(force) {
      if (typeof picker.getVariant === 'function') {
        picker.getVariant().then(function (variant) {
          applyVariant(variant, force);
        }).catch(function () {});
      }
    }

    function scheduleApply(variant) {
      // Shopify can emit several variant events for one click. Never force a
      // gallery rebuild for every event: rebuilding repeatedly can leave
      // Flickity/lightbox DOM handlers behind and cause gallery images to
      // escape their product container (including appearing near the footer).
      if (variant) applyVariant(variant, false);
      [0, 120, 350, 700].forEach(function (delay) {
        window.setTimeout(function () { readVariant(false); }, delay);
      });
    }

    picker.addEventListener('variant-change', function (event) {
      scheduleApply(event.detail && event.detail.variant);
    });

    picker.addEventListener('change', function () {
      scheduleApply(null);
    });

    // Catch any direct variant attribute updates made by the theme.
    try {
      var pickerObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'variant') {
            scheduleApply(null);
          }
        });
      });
      pickerObserver.observe(picker, { attributes: true });
    } catch (e) {}

    // The theme can rebuild the product gallery after variant-change.
    // If it replaces our first image, immediately restore the selected color gallery.
    var gallery = getGallery(section);
    var main = section.querySelector('.product-gallery__main');
    if (gallery && main && typeof MutationObserver !== 'undefined') {
      try {
        var galleryRepairTimer = null;
        var galleryObserver = new MutationObserver(function () {
          if (applying || !activeColor) return;
          if (galleryRepairTimer) window.clearTimeout(galleryRepairTimer);
          galleryRepairTimer = window.setTimeout(function () {
            if (applying || !activeColor) return;
            var currentMain = section.querySelector('.product-gallery__main');
            var desired = data.galleries[activeColor];
            if (!currentMain || !desired || !desired.length) return;
            if (!sameImage(firstImageSrc(currentMain), desired[0].src)) {
              readVariant(false);
            }
          }, 120);
        });
        galleryObserver.observe(main, { childList: true, subtree: true });
      } catch (e) {}
    }

    // Initial state after the theme's product controller has initialized.
    scheduleApply(null);
  }

  function boot() {
    document.querySelectorAll('[data-folivana-color-gallery-data]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll('[data-folivana-color-gallery-data]').forEach(init);
    }
  });
})();
